import { ChangeDetectionStrategy,Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatFormField, MatHint, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

export interface CreateFulfillerAppDialogResult {
    displayName: string;
}

@Component({
    templateUrl: './create-fulfiller-app-dialog.component.html',
    styleUrls: ['./create-fulfiller-app-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatDialogTitle, MatDialogContent, FormsModule, MatFormField, MatLabel, MatInput, MatHint, MatDialogActions, MatButton, MatDialogClose],
})
export class CreateFulfillerAppDialogComponent {
    dialogRef = inject<MatDialogRef<CreateFulfillerAppDialogResult>>(MatDialogRef);


    fulfillerInfo: CreateFulfillerAppDialogResult = {
        displayName: '',
    };

    valid() {
        this.dialogRef.close(this.fulfillerInfo);
    }
}
